import {
  Apiv2GetRequest,
  Apiv2PostRequest,
  Apiv2DeleteRequest,
  Apiv2PutRequest,
  Apiv2PostMultipart,
  Apiv2BlobGetRequest,
} from '../../api-v2';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Ijin / Cuti Karyawan',
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_ijin_karyawan',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'kode_ijin',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'tgl_awal',
        label: 'Tgl Awal',
      },
      {
        key: 'tgl_akhir',
        label: 'Tgl Akhir',
      },
      {
        key: 'hari_ijin',
        label: 'Total Hari',
      },
      {
        key: 'jenis_ijin',
        label: 'Jenis Ijin',
      },
      {
        key: 'status_ijin',
        label: 'Status',
      },
      {
        key: 'aksi',
        thStyle: {
          textAlign: 'center',
          width: '100px',
        },
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeIjinKaryawan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchIjinKaryawan(context, params = null) {
    let result = await Apiv2GetRequest(`ijin-karyawan`, params);
    return !result.error ? result.data.object : [];
  },

  async getTotalNotApproveIjin(context, params = null) {
    let result = await Apiv2GetRequest(`ijin-karyawan/not-approve`, params);
    return !result.error ? (result.data.object ? result.data.object : 0) : 0;
  },

  async getJenisIjin({ commit }) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`jenis-ijin`);
    commit('changeIjinKaryawan', {
      data_jenis_ijin: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListIjinKaryawan({ commit, state }, payload = {}) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      tgl_awal:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      tgl_akhir:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await Apiv2BlobGetRequest(`ijin-karyawan`, params);
      commit('changeIjinKaryawan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_ijin_karyawan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeIjinKaryawan', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await Apiv2GetRequest(`ijin-karyawan`, params);
      commit('changeIjinKaryawan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailIjinKaryawan({ commit }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`ijin-karyawan/${payload.id}`);
    commit('changeIjinKaryawan', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadFileIjin({ commit, state }, payload) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    const { data } = state;
    const result = await Apiv2PostMultipart(`upload-files`, payload);
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeIjinKaryawan', {
        form: {
          ...data.form,
          file_ijin: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PostRequest(`ijin-karyawan/import`, {
      items: data.import_form || [],
    });

    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createIjinKaryawan({ commit, state, dispatch }) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await Apiv2PostRequest(`ijin-karyawan`, state.data.form);
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateIjinKaryawan({ commit, state, dispatch }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await Apiv2PutRequest(
      `ijin-karyawan/${payload.id}`,
      state.data.form,
    );

    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteIjinKaryawan({ commit, dispatch }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await Apiv2DeleteRequest(`ijin-karyawan/${payload.id}`);
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async approveIjinKaryawan({ commit, dispatch }, payload = null) {
    commit('changeIjinKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(
      `ijin-karyawan/${payload.id}/${payload.status}`,
    );
    commit('changeIjinKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
